import { Grid, IconButton, TextField } from '@material-ui/core'
import { Add, Remove } from '@material-ui/icons'
import i18next from 'i18next'
import React from 'react'

const RatesByDays = ({
  item,
  errors,
  displayOnly,
  setRateDay,
  setErrors,
  index,
  length,
  add,
  isFree,
  remove,
}) => {
  const validateValue = (value) => (isNaN(value) ? '' : value)

  return (
    <React.Fragment>
      <Grid item xs={2}>
        <TextField
          label={i18next.t('operator.profile.rates.byDay.days')}
          fullWidth
          value={validateValue(item.days)}
          InputProps={{ readOnly: displayOnly }}
          error={errors.rateDay[index]?.days.message === '' ? false : true}
          helperText={errors.rateDay[index]?.days.message}
          name={'days_' + index}
          onChange={(e) => {
            setRateDay(e, index)
            setErrors(errors)
          }}
          InputLabelProps={{
            shrink: true,
          }}
        />
      </Grid>
      <Grid item xs={2}>
        <TextField
          label={i18next.t('operator.profile.rates.byDay.pricePerDay')}
          fullWidth
          InputProps={{ readOnly: displayOnly }}
          value={validateValue(item.pricePerDay)}
          error={
            errors.rateDay[index]?.pricePerDay.message.length === 0
              ? false
              : true
          }
          helperText={errors.rateDay[index]?.pricePerDay.message}
          name={'pricePerDay_' + index}
          disabled={isFree}
          type="number"
          onChange={(e) => {
            setRateDay(e, index)
            setErrors(errors)
          }}
          InputLabelProps={{
            shrink: true,
          }}
        />
      </Grid>
      <Grid
        item
        xs={1}
        sm={1}
        style={{
          display: 'flex',
          alignItems: 'center',
        }}
      >
        {!displayOnly &&
          (index + 1 == length ? (
            <React.Fragment>
              {length > 1 && (
                <IconButton onClick={() => remove(index)}>
                  <Remove />
                </IconButton>
              )}
              <IconButton onClick={() => add()}>
                <Add />
              </IconButton>
            </React.Fragment>
          ) : (
            <>
              <IconButton onClick={() => remove(index)}>
                <Remove />
              </IconButton>
            </>
          ))}
      </Grid>
      <Grid item xs={2} sm={2}></Grid>
    </React.Fragment>
  )
}

export default RatesByDays
